var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatUploadedDocuments } from '../../pages/UploadDocuments/helpers';
import addCommentApi from '../../services/api/addCommentsApi';
import uploadDocumentsApi from '../../services/api/uploadDocuments';
var submitFilesAndComments = createAsyncThunk('additionalInfo/submitFilesAndComments', function (_, _a) {
    var getState = _a.getState, rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c, acceptedFiles, userComment, _d, accountId, _e, caseId, transactionId, apigeeURL, filesAndCommentsResponse, formattedDocument, uploadDocumentRequest, attachments, error_1, errorJSON, errorCode;
        var _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _b = getState(), _c = _b.additionalInfo, acceptedFiles = _c.acceptedFiles, userComment = _c.userComment, _d = _b.appConfig, accountId = _d.accountId, _e = _d.selectedDispute, caseId = _e.caseId, transactionId = _e.transactionId, apigeeURL = _b.mfeConfig.apigeeURL;
                    filesAndCommentsResponse = {
                        attachments: []
                    };
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 7, , 9]);
                    if (!acceptedFiles.length) return [3 /*break*/, 4];
                    return [4 /*yield*/, formatUploadedDocuments(acceptedFiles.filter(function (_a) {
                            var alreadySubmitted = _a.alreadySubmitted;
                            return !alreadySubmitted;
                        }))];
                case 2:
                    formattedDocument = _g.sent();
                    uploadDocumentRequest = {
                        attachments: formattedDocument
                    };
                    return [4 /*yield*/, uploadDocumentsApi.postFiles({
                            accountId: accountId,
                            apiHost: apigeeURL,
                            caseId: caseId,
                            transactionId: transactionId,
                            uploadDocPayload: uploadDocumentRequest
                        })];
                case 3:
                    attachments = _g.sent();
                    filesAndCommentsResponse.attachments = attachments;
                    _g.label = 4;
                case 4:
                    if (!(userComment !== '')) return [3 /*break*/, 6];
                    return [4 /*yield*/, addCommentApi.postComments({
                            accountId: accountId,
                            apiHost: apigeeURL,
                            caseId: caseId,
                            transactionId: transactionId,
                            notes: userComment
                        })];
                case 5:
                    _g.sent();
                    _g.label = 6;
                case 6: return [2 /*return*/, filesAndCommentsResponse];
                case 7:
                    error_1 = _g.sent();
                    return [4 /*yield*/, error_1.response.json()];
                case 8:
                    errorJSON = _g.sent();
                    if (!((_f = errorJSON === null || errorJSON === void 0 ? void 0 : errorJSON.errors) === null || _f === void 0 ? void 0 : _f.errors)) {
                        return [2 /*return*/, rejectWithValue({ errorCode: null })];
                    }
                    errorCode = Object.keys(errorJSON.errors.errors)[0];
                    return [2 /*return*/, rejectWithValue({
                            errorCode: errorCode
                        })];
                case 9: return [2 /*return*/];
            }
        });
    });
});
export default submitFilesAndComments;
//# sourceMappingURL=submitFilesAndComments.js.map